import React, { Component } from 'react'
class RenderFontURL extends Component {
  render () {
    return (
      <div dangerouslySetInnerHTML={{ __html: `<link rel='stylesheet' type='text/css' href='${this.props.url}' />` }} />
    )
  }
}

export default RenderFontURL



// WEBPACK FOOTER //
// ./src/app/shared/components/RenderFontURL/index.js